// Modules
import React, { ReactNode } from 'react'
import ReactModal from 'react-modal'
import { Icon } from '@dasa-health/alma-react'
import { Close } from '@dasa-health/alma-icons'

// Components
import { Container, HeaderModal, stylesModal } from './styles'

interface Props {
    children: ReactNode
    isOpen: boolean
    onRequestClose: () => void
}

export const Modal: React.VFC<Props> = ({ children, isOpen, onRequestClose }) => (
    <ReactModal isOpen={isOpen} onRequestClose={onRequestClose} preventScroll={false} shouldCloseOnEsc={true} style={stylesModal}>
        <Container>
            <HeaderModal>
                <button data-testid="close-button" onClick={onRequestClose} type="button">
                    <Icon size="md">
                        <Close />
                    </Icon>
                </button>
            </HeaderModal>
            {children}
        </Container>
    </ReactModal>
)
